import { render, staticRenderFns } from "./CouponRuleList.vue?vue&type=template&id=1a8e503e&scoped=true"
import script from "./CouponRuleList.vue?vue&type=script&lang=js"
export * from "./CouponRuleList.vue?vue&type=script&lang=js"
import style0 from "./CouponRuleList.vue?vue&type=style&index=0&id=1a8e503e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e503e",
  null
  
)

export default component.exports